import { RouteConfig } from 'vue-router';

function buildPublicImportPath(fileName) {
  return import(`@/pages/public/${fileName}`);
}
function buildBudtenderImportPath(fileName) {
  return import(`@/pages/budtender/${fileName}`);
}
function buildBrandImportPath(fileName) {
  return import(`@/pages/brand/${fileName}`);
}
function buildAdminImportPath(fileName) {
  return import(`@/pages/admin/${fileName}`);
}
function buildSuperAdminImportPath(fileName) {
  return import(`@/pages/superadmin/${fileName}`);
}

/** *  ---  Public Routes  --- */

export const LOGIN_PAGE: RouteConfig = {
  name: 'Login',
  path: 'login',
  component: () => buildPublicImportPath('LoginPage.vue'),
  meta: {
    title: 'Login',
  },
};

export const SUPERADMIN_LOGIN_PAGE: RouteConfig = {
  name: 'SuperAdminLogin',
  path: 'login/superadmin',
  component: () => buildPublicImportPath('SuperAdminLogin.vue'),
  meta: {
    title: 'Login',
  },
};

export const PASSWORD_RESET: RouteConfig = {
  name: 'PasswordReset',
  path: 'password_reset',
  component: () => buildPublicImportPath('PasswordReset.vue'),
  meta: {
    title: 'Password Reset',
  },
};

export const BRAND_LOGIN_PAGE: RouteConfig = {
  name: 'BrandLogin',
  path: 'login/brand',
  component: () => buildPublicImportPath('BrandLogin.vue'),
  meta: {
    title: 'Brand Login',
  },
};

export const LANDING_PAGE: RouteConfig = {
  name: 'PublicHomePage',
  path: '',
  component: () => buildPublicImportPath('LandingPage.vue'),
  meta: {
    title: 'Welcome',
  },
};

export const REGISTER_PAGE: RouteConfig = {
  name: 'Register',
  path: 'register',
  component: () => buildPublicImportPath('Register.vue'),
  meta: {
    title: 'Register',
  },
};

export const REGISTER_BRAND_PAGE: RouteConfig = {
  name: 'RegisterBrand',
  path: 'register/brand',
  component: () => buildPublicImportPath('RegisterBrand.vue'),
  meta: {
    title: 'Register',
  },
};

export const REGISTER_ADMIN_PAGE: RouteConfig = {
  name: 'RegisterBrandAdmin',
  path: 'register/admin/:adminId',
  component: () => buildPublicImportPath('RegisterAdmin.vue'),
  meta: {
    title: 'Register',
  },
};

export const REGISTER_BUDTENDER_PAGE: RouteConfig = {
  name: 'RegisterBudtender',
  path: 'register/budtender/:budtenderId',
  component: () => buildPublicImportPath('RegisterBudtender.vue'),
  meta: {
    title: 'Register',
  },
};


/** *  ---  Brand Routes  --- */

export const HOME_PAGE: RouteConfig = {
  name: 'HomePage',
  path: '',
  component: () => buildBrandImportPath('HomePage.vue'),
  meta: {
    title: 'Home',
  },
};

export const BRAND_CENTER_PAGE: RouteConfig = {
  name: 'BrandCenterPage',
  path: 'brand',
  component: () => buildBrandImportPath('BrandCenterPage.vue'),
  meta: {
    title: 'Brand Center',
  },
};

export const BRAND_PRODUCT_PAGE = {
  name: 'BrandProductPage',
  path: 'products',
  component: (): Promise<any> => buildBrandImportPath('ProductPage.vue'),
  meta: {
    title: 'Products',
  },
};

export const VIDEO_VAULT_PAGE: RouteConfig = {
  name: 'VideoVaultPage',
  path: 'broadcast',
  component: () => buildBrandImportPath('VideoVault.vue'),
  meta: {
    title: 'Video Vault',
  },
};
export const LEARNING_CENTER_PAGE: RouteConfig = {
  name: 'LearningCenterPage',
  path: 'meet',
  component: () => buildBrandImportPath('MeetingRoom.vue'),
  meta: {
    title: 'Meeting Center',
  },
};

export const MEET_TEAM_PAGE: RouteConfig = {
  name: 'MeetTeamPage',
  path: 'learn/team',
  component: () => buildBrandImportPath('TeamPage.vue'),
  meta: {
    title: 'Meet the Team',
  },
};
export const BUDTENDER_HUB_PAGE: RouteConfig = {
  name: 'BudtenderHubPage',
  path: 'budtenders/:quiz',
  component: () => buildBrandImportPath('BudtenderHubPage.vue'),
  meta: {
    title: 'Budtender Hub',
  },
};
export const BUDTENDER_MENU_PAGE: RouteConfig = {
  name: 'BudtenderMenuPage',
  path: 'budtenders',
  component: () => buildBrandImportPath('BudtenderMenuPage.vue'),
  meta: {
    title: 'Budtender Hub',
  },
};
export const MERCH_MARKET: RouteConfig = {
  name: 'MerchMarket',
  path: 'merch',
  component: () => buildBrandImportPath('MerchPage.vue'),
  meta: {
    title: 'Merch Market',
  },
};

/** *  ---  Budtender Portal Routes  --- */

export const BUDTENDER_PORTAL: RouteConfig = {
  name: 'BudtenderPortal',
  path: '',
  component: () => buildBudtenderImportPath('HomePage.vue'),
  meta: {
    title: 'Your Shelf',
  },
};

export const BUDTENDER_USER_LIST: RouteConfig = {
  name: 'BudtenderUserList',
  path: 'users',
  component: () => buildBudtenderImportPath('UserListPage.vue'),
  meta: {
    title: 'Users',
  },
};

export const BUDTENDER_COA_SEARCH: RouteConfig = {
  name: 'BudtenderCoaSearch',
  path: 'coa',
  component: () => buildBudtenderImportPath('CoaSearchPage.vue'),
  meta: {
    title: 'COA Search',
  },
};

/** *  ---  Admin Routes  --- */

export const ADMIN_DASHBOARD: RouteConfig = {
  name: 'AdminDashboardPage',
  path: '',
  component: () => buildAdminImportPath('AdminDashboardPage.vue'),
  meta: {
    title: 'Settings',
  },
};

export const ADMIN_BROADCAST_CENTER: RouteConfig = {
  name: 'AdminMeetingPage',
  path: 'meeting',
  component: () => buildAdminImportPath('AdminMeetingPage.vue'),
  meta: {
    title: 'Meetings',
  },
};

export const ADMIN_BRAND_ASSETS: RouteConfig = {
  name: 'AdminAssetsPage',
  path: 'assets',
  component: () => buildAdminImportPath('AdminAssetsPage.vue'),
  meta: {
    title: 'Assets',
  },
};
export const ADMIN_VIDEO_VAULT: RouteConfig = {
  name: 'AdminVideoVault',
  path: 'video',
  component: () => buildAdminImportPath('AdminVideoVault.vue'),
  meta: {
    title: 'Videos',
  },
};
export const ADMIN_USERS_PAGE = {
  name: 'AdminUserListPage',
  path: 'users',
  component: (): Promise<any> => buildAdminImportPath('AdminUserListPage.vue'),
  meta: {
    title: 'Users',
  },
};
export const ADMIN_DISPENSARY_PAGE = {
  name: 'AdminDispensaryList',
  path: 'dispensaries',
  component: (): Promise<any> => buildAdminImportPath('AdminDispensaryList.vue'),
  meta: {
    title: 'Dispensaries',
  },
};

export const ADMIN_PRODUCT_INFORMATION = {
  name: 'AdminProductInformation',
  path: 'products',
  component: (): Promise<any> => buildAdminImportPath('AdminProductInformation.vue'),
  meta: {
    title: 'Products',
  },
};

export const ADMIN_PRODUCT_COA = {
  name: 'AdminProductCOA',
  path: 'coas',
  component: (): Promise<any> => buildAdminImportPath('AdminCOAPage.vue'),
  meta: {
    title: 'COAs',
  },
};

export const SUPERADMIN_HOME = {
  name: 'SuperAdminHomePage',
  path: '',
  component: (): Promise<any> => buildSuperAdminImportPath('HomePage.vue'),
  meta: {
    title: 'SuperAdmin',
  },
};


export const TOP_PUBLIC_BAR: Array<RouteConfig> = [
  BRAND_CENTER_PAGE,
  BRAND_PRODUCT_PAGE,
];

export const ADMIN_ROUTES = [
  ADMIN_BRAND_ASSETS,
  ADMIN_PRODUCT_INFORMATION,
  ADMIN_PRODUCT_COA,
  ADMIN_VIDEO_VAULT,
  ADMIN_BROADCAST_CENTER,
  ADMIN_USERS_PAGE,
  ADMIN_DISPENSARY_PAGE,
  ADMIN_DASHBOARD,
];

export const BUDTENDER_ROUTES = [
  BUDTENDER_PORTAL,
  BUDTENDER_COA_SEARCH,
  BUDTENDER_USER_LIST,
];

const ALL_ROUTES = {
  PUBLIC: [
    LANDING_PAGE,
    BRAND_LOGIN_PAGE,
    LOGIN_PAGE,
    REGISTER_PAGE,
    REGISTER_BRAND_PAGE,
    REGISTER_ADMIN_PAGE,
    REGISTER_BUDTENDER_PAGE,
    PASSWORD_RESET,
    SUPERADMIN_LOGIN_PAGE,
  ],
  BUDTENDER: BUDTENDER_ROUTES,
  BRAND: [
    MERCH_MARKET,
    HOME_PAGE,
    BRAND_CENTER_PAGE,
    BRAND_PRODUCT_PAGE,
    VIDEO_VAULT_PAGE,
    LEARNING_CENTER_PAGE,
    BUDTENDER_HUB_PAGE,
    BUDTENDER_MENU_PAGE,
    MEET_TEAM_PAGE,
  ],
  ADMIN: ADMIN_ROUTES,
  SUPER_ADMIN: [SUPERADMIN_HOME],
};

export default ALL_ROUTES;
